import { LanguageEnum, SHORT_LINK_KEY } from '@optionway/models';

export const isShortLink = (query: Record<string, unknown>): boolean => SHORT_LINK_KEY in query;

// The empty entry is the unprefixed root, served for the default locale by the prefix_and_default strategy.
export const LOCALES = ['', ...Object.values(LanguageEnum)];
// Pages reachable directly, by an external link or a bookmark. Anything else is redirected by funnel-guard.
export const ENTRY_POINTS = [
  '',
  'results',
  'pending',
  'terms',
  'privacy-policy',
  'legal-notices',
  'accessibility',
  'my-booking/login',
] as const;

const buildEntryPointPaths = (): string[] => {
  const paths: string[] = [];

  for (const locale of LOCALES) {
    for (const entryPoint of ENTRY_POINTS) {
      const path = [locale, entryPoint].filter((segment) => segment !== '').join('/');
      paths.push(`/${path}`);
    }
  }

  return paths;
};

export const ENTRY_POINT_PATHS = buildEntryPointPaths();
export const isEntryPoint = (path: string): boolean => ENTRY_POINT_PATHS.includes(path);

// The same list as route names, to compare with routeBaseName(): Nuxt joins nested segments with a dash.
export const ENTRY_POINT_NAMES = new Set<string>(ENTRY_POINTS.map((page) => page.replaceAll('/', '-') || 'index'));

// Read by server/plugins/08.document-cache.ts. /pending and /results answer one record or one search each.
export const CACHEABLE_DOCUMENT_PATHS = new Set<string>(
  ENTRY_POINT_PATHS.filter((path) => !path.endsWith('/pending') && !path.endsWith('/results')),
);

// Every page under /my-booking but its login needs the booking's access: it guards itself, from any entry.
export const isPrivateBookingPage = (routeName: string): boolean =>
  routeName.startsWith('my-booking') && routeName !== 'my-booking-login';
